import React from 'react';
import { FeatureGate } from './FeatureGate';
import { useSubscription } from '../hooks/useSubscription';

export const FeatureGateTest: React.FC = () => {
  const {
    loading,
    error,
    effectiveTier,
    isSubscriptionActive,
    data: subscriptionData
  } = useSubscription();

  if (loading) {
    return <div className="p-4">Loading subscription status...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="p-4 space-y-6">
      <div className="bg-gray-100 p-4 rounded-lg">
        <h2 className="text-xl font-bold mb-2">Current Subscription Status</h2>
        <pre className="bg-white p-2 rounded">
          {JSON.stringify({
            tier: effectiveTier,
            isActive: isSubscriptionActive,
            subscriptionData
          }, null, 2)}
        </pre>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold">Feature Access Test</h2>
        
        {/* Free Features */}
        <div className="border p-4 rounded">
          <h3 className="font-semibold mb-2">Free Features</h3>
          <FeatureGate requiredTier="free">
            <div className="bg-green-100 p-2 rounded">
              ✓ This feature should be visible to all users
            </div>
          </FeatureGate>
        </div>

        {/* Basic Features */}
        <div className="border p-4 rounded">
          <h3 className="font-semibold mb-2">Basic Features</h3>
          <FeatureGate requiredTier="basic">
            <div className="bg-green-100 p-2 rounded">
              ✓ This feature should be visible to Basic and Pro users
            </div>
          </FeatureGate>
          <FeatureGate 
            requiredTier="basic" 
            fallback={
              <div className="bg-yellow-100 p-2 rounded">
                ⚠️ This is a fallback view for Basic features
              </div>
            }
          >
            <div className="bg-green-100 p-2 rounded">
              ✓ This feature has a fallback view
            </div>
          </FeatureGate>
        </div>

        {/* Pro Features */}
        <div className="border p-4 rounded">
          <h3 className="font-semibold mb-2">Pro Features</h3>
          <FeatureGate requiredTier="pro">
            <div className="bg-green-100 p-2 rounded">
              ✓ This feature should only be visible to Pro users
            </div>
          </FeatureGate>
          <FeatureGate 
            requiredTier="pro" 
            showUpgradePrompt={false}
          >
            <div className="bg-green-100 p-2 rounded">
              ✓ This Pro feature has no upgrade prompt
            </div>
          </FeatureGate>
        </div>
      </div>
    </div>
  );
}; 